import { createSelector } from "@reduxjs/toolkit";
import type { IRootState } from "../../app/store";
import {
  DesignLeftSideBarTabs,
  LEFT_SIDEBAR_TABS_BY_MODULE,
} from "@multiconsult-group/multiplacer-core";
export const selectAllowedLeftSidebarTabs = createSelector(
  [(state: IRootState) => state.design.activeModule],
  (activeModule): DesignLeftSideBarTabs[] => {
    return activeModule ? LEFT_SIDEBAR_TABS_BY_MODULE[activeModule] : [];
  }
);

export const selectVisibleLeftSidebarTab = createSelector(
  [(state: IRootState) => state.design.activeLeftSideBarTab, selectAllowedLeftSidebarTabs],
  (tab, allowed) => (tab != null && allowed.includes(tab) ? tab : undefined)
);
